import { render, staticRenderFns } from "./login_small_print.vue?vue&type=template&id=b922edda&"
import script from "./login_small_print.vue?vue&type=script&lang=js&"
export * from "./login_small_print.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b922edda')) {
      api.createRecord('b922edda', component.options)
    } else {
      api.reload('b922edda', component.options)
    }
    module.hot.accept("./login_small_print.vue?vue&type=template&id=b922edda&", function () {
      api.rerender('b922edda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/login/login_small_print.vue"
export default component.exports